<td>{{ description() }}</td>
<td>{{ prefix() }}</td>
<td class="nowrap">{{ startDate() | date: "d MMM y, HH:mm" }}</td>
<td>{{ ipVersion() }}</td>
<td>
  <div class="table-properties__flex">
    @if (ipSubscriptionsCount() > 0) {
      <div class="table-link" (click)="openDialog()">
        {{ ipSubscriptionsCount() }}
        {{ ipSubscriptionsCount() === 1 ? ("Ipprefixes.Service" | translate) : ("Ipprefixes.Services" | translate) }}
      </div>
    } @else {
      <div>
        <b>{{ "Ipprefixes.NotInuse" | translate }}</b>
      </div>
    }
    @if (canEdit() && prefix().startsWith("145.98")) {
      <div class="table-overflow-menu">
        <div class="table-settings">
          <svg-icon src="assets/images/icons/cog.svg"></svg-icon>
        </div>
        <div class="overflow-menu__items">
          <div class="overflow-menu__item" (click)="openAddDialog()">
            {{ "OverflowMenu.Link" | translate }}
          </div>
        </div>
      </div>
    }
  </div>
</td>
